import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../store/auth';
import BackBtn from '../components/BackBtn';

export default function Activity() {
  const { deviceId } = useParams();
  const navigate = useNavigate();
  const [activity, setActivity] = useState([]);

  const load = async () => {
    const { data } = await api.get(`/devices/${deviceId}/activity?limit=500`);
    setActivity(data);
  };

  useEffect(() => { load(); }, [deviceId]);

  // Aggregate by app
  const byApp = activity.reduce((acc, a) => {
    const key = a.application || 'unknown';
    acc[key] = (acc[key] || 0) + (a.duration_sec || 0);
    return acc;
  }, {});

  const topApps = Object.entries(byApp)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);

  const fmt = (sec) => {
    if (sec < 60) return `${sec}s`;
    if (sec < 3600) return `${Math.floor(sec/60)}m`;
    return `${Math.floor(sec/3600)}h ${Math.floor((sec%3600)/60)}m`;
  };

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:20 }}>
        <BackBtn onClick={() => navigate(`/device/${deviceId}`)} />
        <h2 style={{ fontWeight:700 }}>Activity Log</h2>
        <button onClick={load} style={btnStyle}>Refresh</button>
      </div>

      {/* Top apps */}
      <div style={{ marginBottom:24 }}>
        <h3 style={{ fontSize:13, color:'var(--muted)', marginBottom:10, textTransform:'uppercase', letterSpacing:.5 }}>
          Top Applications
        </h3>
        {topApps.map(([app, sec]) => {
          const total = topApps[0]?.[1] || 1;
          return (
            <div key={app} style={{ marginBottom:8 }}>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, marginBottom:2 }}>
                <span>{app}</span><span style={{ color:'var(--muted)' }}>{fmt(sec)}</span>
              </div>
              <div style={{ height:4, background:'var(--border)', borderRadius:2 }}>
                <div style={{ width:`${(sec/total)*100}%`, height:'100%',
                  background:'var(--accent)', borderRadius:2 }} />
              </div>
            </div>
          );
        })}
      </div>

      {/* Timeline */}
      <div style={{ fontFamily:'monospace', fontSize:12 }}>
        {activity.map((a, i) => (
          <div key={i} style={{ display:'flex', gap:12, padding:'8px 12px',
            borderBottom:'1px solid var(--border)', alignItems:'flex-start' }}>
            <span style={{ color:'var(--muted)', width:130, flexShrink:0, fontSize:11 }}>
              {a.started_at ? new Date(a.started_at+'Z').toLocaleString() : '?'}
            </span>
            <span style={{ color:'var(--accent)', width:120, flexShrink:0 }}>{a.application}</span>
            <span style={{ flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
              {a.window_title}
            </span>
            <span style={{ color:'var(--muted)', width:50, textAlign:'right' }}>
              {fmt(a.duration_sec || 0)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

const btnStyle = {
  padding:'6px 14px', background:'transparent', border:'1px solid var(--border)',
  borderRadius:6, color:'var(--muted)', cursor:'pointer',
};
